var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-holder"},[_vm._t("form",null,{"getNote":_vm.getNote.notes,"on":_vm.setNote}),_vm._t("actions",null,{"note":_vm.getNote})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }